<template>
  <div class="move-tabs">
    <div class="tabs-wrapper" ref="tabsWrapper">
      <ul ref="tab" style="position:absolute">
        <li v-for="(item, index) in tabs" :key="index">
          <div class="tab-item">
            <div class="expand-block">
              {{ item.name || "无" }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";

export default {
  name: "LeftScroll",
  components: {},
  props: {
    data: Array,
  },
  data() {
    return {
      tabs: [],
      mX: 0,
      tabWidth: 280,
    };
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.data);
      this.tabs = this.data;
      this._initMenu();
    });
  },
  mounted() {
    this.$nextTick(() => {
      this._initMenu();
    });
  },

  methods: {
    _initMenu() {
      this.tabs = this.data;
      console.log(JSON.stringify(this.data));
      const tabsWidth = this.tabWidth;
      const width = this.tabs.length * tabsWidth;
      this.$refs.tab.style.width = `${width}px`;
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.tabsWrapper, {
            scrollX: true,
            eventPassthrough: "vertical",
          });
        } else {
          this.scroll.refresh();
        }
      });
    },
  },
};
</script>

<style scoped>
.move-tabs {
  position: relative;
  top: 0;
  bottom: 0;
  width: 100%;
}
.tabs-wrapper {
  height: 120px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
}
.tab-item {
  float: left;
  width: 280px;
  height: 120px;
  padding: 10px;
  margin-right: 20px;
  background: #f5f5;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.expand-block {
  font-size: 30px;
  font-weight: bold;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/leftscroll.vue